import { PolymorphicComponentPropWithRef } from "@omni/types/components/utils/polymorphic.types";
import { cn } from "@omni/utils/styles";
import React from "react";

export type TrComponentProps = {
    striped?: boolean;
};

export type TrProps<T extends React.ElementType> =
    PolymorphicComponentPropWithRef<T, TrComponentProps, "tr">;

const Tr = <T extends React.ElementType = "tr">({
    ref,
    className,
    striped,
    tag,
    innerRef: _innerRef,
    children,
    ...attributes
}: TrProps<T>) => {
    const Tag = tag || ("tr" as React.ElementType);

    const classes = cn(
        striped ? "tw:nth-of-type-[odd]:bg-black/5" : "",
        className
    );

    const table = (
        <Tag
            {...attributes}
            ref={ref}
            className={classes}
        >
            {children}
        </Tag>
    );

    return table;
};

export { Tr };
